import Cookies from 'universal-cookie';
import { Box } from '@chakra-ui/react';
import TableTemplate from '@components/tableTemplate';
import { useStockTrailFilterStore, useStockTrailStore } from '@pages/StockTrail/helpers/mainState';
import { tableListStore, TableListNotStore } from './const';
import React from 'react';
import './styles.scss';

const Table = () => {
    const cookies = new Cookies();
    const userRole = cookies.get('role');
    const { paginationInfo, isLoadingTable, trails } = useStockTrailStore();
    const { onChangeStockTrailFilterSelectedStore, page } = useStockTrailFilterStore();
    const handlePageClick = ({ selected }) => onChangeStockTrailFilterSelectedStore({ page: selected + 1 });

    const tableList = userRole?.includes('super user') ? tableListStore : TableListNotStore;

    return (
        <Box className="table-stock-trail__container">
            <TableTemplate
                tableList={tableList}
                data={trails}
                dataCount={paginationInfo?.dataCount}
                totalData={paginationInfo?.totalData}
                page={page}
                totalPage={paginationInfo?.totalPage}
                handlePageClick={handlePageClick}
                isPagination={true}
                isDynamicTable={false}
                isLoading={isLoadingTable}
                overflowTable="visible"
            />
        </Box>
    );
};

export default Table;
